const getEnv = state => state.env;

const EnvSelectors = {
    makeZgEnv: state => getEnv(state).zgEnv,
    makeZgApi: state => getEnv(state).zgApi,
    makeZgApiPublic: state => getEnv(state).zgApiPublic,
    makeMetroidConfigUrlCapture: state => getEnv(state).metroidConfigUrlCapture,
    makeMetroidConfigUrlCharge: state => getEnv(state).metroidConfigUrlCharge,
    makeMetroidProductId: state => getEnv(state).metroidProductId,
    makeIsProduction: state => getEnv(state).isProduction,
    makeGmapsAPIKey: state => getEnv(state).gmapsAPIKey,
};

export default EnvSelectors;
